import WebRequest from '@common/logic/src/request/web-request';
import EvoRequest from '@common/logic/src/request/tv_evo-request';

export const request = import.meta.env.EVO ? new EvoRequest() : new WebRequest();
